/**
 * Datos del mapa galáctico "Archilele's Two Word Guide to the 'Verse" (Star Citizen).
 * Coordenadas originales: 1000×600, origen top_left.
 * Se exportan posiciones normalizadas en % (0–100) para el starmap.
 */

const WIDTH = 1000;
const HEIGHT = 600;

/** Mapeo dominant_power → type del starmap (uee | vanduul | xian | banu | unclaimed) */
export function dominantPowerToType(dominantPower) {
    if (!dominantPower) return 'unclaimed';
    const p = String(dominantPower).toLowerCase();
    if (p.includes('uee') || p.includes('human')) return 'uee';
    if (p.includes('vanduul')) return 'vanduul';
    if (p.includes("xi'an") || p.includes('xian')) return 'xian';
    if (p.includes('banu')) return 'banu';
    return 'unclaimed';
}

/** Sistemas con coordenadas en espacio original 1000×600 */
export const ARCHILELE_SYSTEMS = [
    { id: 'branaugh', name: 'Branaugh', x: 190, y: 85, dominant_power: 'UEE Tevarin', region: 'UEE Fringe' },
    { id: 'odin', name: 'Odin', x: 200, y: 110, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'chronos', name: 'Chronos', x: 260, y: 145, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'kellog', name: 'Kellog', x: 185, y: 210, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'tanga', name: 'Tanga', x: 215, y: 205, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'vector', name: 'Vector', x: 135, y: 180, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'veritas', name: 'Veritas', x: 85, y: 250, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vermillion', name: 'Vermillion', x: 95, y: 290, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'virgo', name: 'Virgo', x: 115, y: 335, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vulture', name: 'Vulture', x: 105, y: 315, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'viking', name: 'Viking', x: 110, y: 360, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vagabond', name: 'Vagabond', x: 120, y: 420, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vesper', name: 'Vesper', x: 105, y: 485, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vanguard', name: 'Vanguard', x: 135, y: 510, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'vendetta', name: 'Vendetta', x: 150, y: 435, dominant_power: 'Vanduul', region: 'Vanduul' },
    { id: 'virgil', name: 'Virgil', x: 245, y: 250, dominant_power: 'UEE', region: 'Border' },
    { id: 'tiber', name: 'Tiber', x: 165, y: 275, dominant_power: 'UEE', region: 'Border' },
    { id: 'orion', name: 'Orion', x: 175, y: 325, dominant_power: 'Vanduul', region: 'Vanduul Border' },
    { id: 'oberon', name: 'Oberon', x: 215, y: 375, dominant_power: 'UEE Tevarin', region: 'Border' },
    { id: 'elysium', name: 'Elysium', x: 165, y: 495, dominant_power: 'UEE Tevarin', region: 'UEE Tevarin' },
    { id: 'leir', name: 'Leir', x: 185, y: 560, dominant_power: 'Outsiders', region: 'UEE Tevarin Border' },
    { id: 'kabal', name: 'Kabal', x: 300, y: 525, dominant_power: 'UEE Tevarin', region: 'UEE Tevarin' },
    { id: 'garron', name: 'Garron', x: 370, y: 515, dominant_power: 'UEE', region: 'UEE Tevarin' },
    { id: 'idris', name: 'Idris', x: 365, y: 455, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'banshee', name: 'Banshee', x: 420, y: 545, dominant_power: 'UEE', region: 'UEE Tevarin/Banu Border' },
    { id: 'tamsa', name: 'Tamsa', x: 470, y: 575, dominant_power: 'UEE', region: 'UEE Tevarin/Banu Border' },
    { id: 'fora', name: 'Fora', x: 430, y: 690, dominant_power: 'UEE', region: 'Southern Border' },
    { id: 'yulin', name: 'Yulin', x: 540, y: 585, dominant_power: 'Banu', region: 'Banu Border' },
    { id: 'vega', name: 'Vega', x: 355, y: 200, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'bremen', name: 'Bremen', x: 435, y: 160, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'oso', name: 'Oso', x: 495, y: 195, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'nyx', name: 'Nyx', x: 430, y: 115, dominant_power: 'Unclaimed', region: 'Unclaimed' },
    { id: 'tohil', name: 'Tohil', x: 505, y: 110, dominant_power: 'Smugglers', region: 'Unclaimed' },
    { id: 'trise', name: 'Trise', x: 470, y: 35, dominant_power: 'Banu', region: 'Northern Fringe' },
    { id: 'virtus', name: 'Virtus', x: 480, y: 75, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'eealus', name: 'Eaalus', x: 535, y: 55, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'oya', name: 'Oya', x: 545, y: 135, dominant_power: 'UEE', region: 'UEE Fringe' },
    { id: 'rilah', name: 'Rilah', x: 680, y: 85, dominant_power: 'UEE', region: 'UEE Fringe / Xi\'an Border' },
    { id: 'kaya', name: 'Kaya', x: 750, y: 20, dominant_power: 'UEE', region: 'Northern Border' },
    { id: 'elsin', name: 'El\'sin', x: 815, y: 60, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'khabari', name: 'Khabari', x: 890, y: 70, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'markahil', name: 'Markahil', x: 950, y: 145, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'tal', name: 'Tal', x: 930, y: 245, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'pallas', name: 'Pallas', x: 810, y: 285, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'ayrka', name: 'Ayr\'ka', x: 965, y: 360, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'hadur', name: 'Hadur', x: 865, y: 470, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'indra', name: 'Indra', x: 800, y: 535, dominant_power: 'Xi\'an', region: 'Xi\'an' },
    { id: 'horus', name: 'Horus', x: 755, y: 225, dominant_power: 'UEE', region: 'UEE Terra / Xi\'an Border' },
    { id: 'gurzil', name: 'Gurzil', x: 690, y: 190, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'castra', name: 'Castra', x: 540, y: 230, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'hadrian', name: 'Hadrian', x: 615, y: 385, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'kiel', name: 'Kiel', x: 675, y: 400, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'pyro', name: 'Pyro', x: 500, y: 360, dominant_power: 'Unclaimed', region: 'Unclaimed' },
    { id: 'stanton', name: 'Stanton', x: 585, y: 435, dominant_power: 'UEE', region: 'UEE Corporate' },
    { id: 'terra', name: 'Terra', x: 645, y: 505, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'baker', name: 'Baker', x: 710, y: 545, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'magnus', name: 'Magnus', x: 540, y: 500, dominant_power: 'UEE', region: 'UEE Terra' },
    { id: 'kilian', name: 'Kilian', x: 455, y: 535, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'cano', name: 'Cano', x: 380, y: 530, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'sol', name: 'Sol', x: 340, y: 440, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'kallis', name: 'Kallis', x: 430, y: 415, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'croshaw', name: 'Croshaw', x: 255, y: 520, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'davien', name: 'Davien', x: 310, y: 575, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'ferron', name: 'Ferron', x: 260, y: 605, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'centauri', name: 'Centauri', x: 430, y: 350, dominant_power: 'UEE', region: 'UEE Earth' },
    { id: 'oretani', name: 'Oretani', x: 470, y: 320, dominant_power: 'Unclaimed', region: 'Drift' },
    { id: 'caliban', name: 'Caliban', x: 190, y: 390, dominant_power: 'Vanduul', region: 'Vanduul Border' },
    { id: 'cathcart', name: 'Cathcart', x: 430, y: 585, dominant_power: 'Unclaimed', region: 'Junkyard Border' },
    { id: 'nexus', name: 'Nexus', x: 560, y: 610, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'hades', name: 'Hades', x: 615, y: 555, dominant_power: 'Ancient Ruins', region: 'UEE Frontier' },
    { id: 'rhetor', name: 'Rhetor', x: 610, y: 635, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'nemo', name: 'Nemo', x: 650, y: 680, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'min', name: 'Min', x: 560, y: 645, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'ellis', name: 'Ellis', x: 505, y: 565, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'tayac', name: 'Tayac', x: 630, y: 620, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'helios', name: 'Helios', x: 705, y: 675, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'taranis', name: 'Taranis', x: 565, y: 675, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'corel', name: 'Corel', x: 510, y: 760, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'genesis', name: 'Genesis', x: 665, y: 735, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'charon', name: 'Charon', x: 735, y: 770, dominant_power: 'UEE', region: 'UEE Frontier / Banu Border' },
    { id: 'tyrol', name: 'Tyrol', x: 695, y: 840, dominant_power: 'UEE', region: 'Banu Border' },
    { id: 'kins', name: 'Kins', x: 820, y: 775, dominant_power: 'Banu', region: 'Banu' },
    { id: 'geddon', name: 'Geddon', x: 595, y: 855, dominant_power: 'Banu', region: 'Banu' },
    { id: 'gliese', name: 'Gliese', x: 635, y: 930, dominant_power: 'Banu', region: 'Banu' },
    { id: 'bacchus', name: 'Bacchus', x: 725, y: 635, dominant_power: 'Banu Border', region: 'Banu Border' },
    { id: 'goss', name: 'Goss', x: 820, y: 615, dominant_power: 'UEE', region: 'UEE Frontier' },
    { id: 'osiris', name: 'Osiris', x: 775, y: 600, dominant_power: 'UEE', region: 'UEE Frontier / Xi\'an Border' }
];

/** Convierte coordenadas 1000×600 (top_left) a porcentaje 0–100 (x, y). Clamp por si hay valores fuera de rango. */
export function normalizePosition(x, y) {
    return {
        x: Math.max(0, Math.min(100, (Number(x) / WIDTH) * 100)),
        y: Math.max(0, Math.min(100, (Number(y) / HEIGHT) * 100))
    };
}

/** Objeto { systemId: { x, y } } en % para usar con POSICIONES_MAPA */
export function getPositionsFromArchilele() {
    const out = {};
    ARCHILELE_SYSTEMS.forEach((s) => {
        out[s.id] = normalizePosition(s.x, s.y);
    });
    return out;
}

export const META = {
    source: "Archilele's Two Word Guide to the 'Verse / Star Citizen galactic travel chart",
    coordinate_system: { type: 'normalized_2d', width: WIDTH, height: HEIGHT, origin: 'top_left' }
};
